import React from 'react';

interface KioskNavigationFooterProps {
    leftButton?: React.ReactNode;
    rightButton?: React.ReactNode;
}

export const KioskNavigationFooter = (props: KioskNavigationFooterProps) => {
    return (
        <footer className='bg-background-surface border-border-default inline-flex flex-col items-start justify-start gap-4 self-stretch border-t px-6 py-4'>
            <div className='inline-flex items-start justify-between self-stretch'>
                <div>{props.leftButton}</div>
                <div>{props.rightButton}</div>
            </div>
        </footer>
    );
};
